module.exports = __webpack_public_path__ + "static/media/g_1611874578_aee0ebc9ca5b4e5a955a8205a5800f78.7f170b5a.jpeg";